/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'

import useMediaQuery from '@mui/material/useMediaQuery'

import {get} from 'lodash'

import {makeGetArtistById} from '../../../selectors'

import {formatInfoPageAddress} from '../../../utils'

import MailIcon from '@mui/icons-material/Mail'
import PhoneIcon from '@mui/icons-material/Phone'
import GlobeIcon from '@mui/icons-material/Language'

import ArtistBands from './ArtistBands'
import ArtistButtons from './ArtistButtons'



import { 
  Tags,
  // ViewCount,
  Broadcast,
  LinksList,
  WebsiteLink,
  DetailPageTitle,
  DetailPageSection,
  InfoExpandingText
} from '../../generics'




const styles = {
  root: css`
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    max-width: 550px;
  `,
  titleContainer: css`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    gap: 30px;

    @media (max-width: 1120px) {
      justify-content: space-between;
      padding: 0px 25px;
    }

    @media (max-width: 768px) {
      gap: 20px;
    }
  `,
  innerTitleContainer: css`
    max-width: 80vw;
  `,
  mainButtonContainer: css`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #262626;
    border-radius: 50%;
    flex: 0 0 60px;
    z-index: 15;

    svg {
      width: 27px;
      height: 27px;
    }

    @media (max-width: 1120px) {
      position: absolute;
      top: -25px;
      right: 20px;
    }
  `,
  buttonContainer: css`
    @media (max-width: 1120px) {
      padding: 0px;

      #button-row {
        width: auto;
        padding-right: 25px;
        padding-left: 25px;
      }
    }
  `,
  broadcastContainer: css`
    @media (max-width: 1120px) {
      padding: 0px 25px;
    }
  `,
  body: css`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    margin-bottom: 20px;
    margin-top: 10px;

    @media (max-width: 1120px) {
      padding: 0px 25px;
    }
  `,
  footer: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    @media (max-width: 1120px) {
      padding: 0px 25px;
    }
  `
}



const ArtistInfo = props => {

  const isLargeScreen = useMediaQuery('(min-width:1120px)')


  const { 
    isOwner,
    artistId, 
    name, 
    bio, 
    tags,
    // views,
    email,
    links,
    setLinks,
    externalLinks,
    address, 
    website,
    phoneNumber
  } = props


  const hasExternalLinks = Object.values(externalLinks).filter(value => !!value).length > 0



  return (
    <div css={styles.root}>
      <div id='title-container' css={styles.titleContainer}>
        <div css={styles.innerTitleContainer}>
          <DetailPageTitle 
            caption='artist'
            title={name}
            subtitle={formatInfoPageAddress(address)} 
          />
        </div>
      </div>

      {/*<ViewCount views={views} />*/}

     
      <div css={styles.buttonContainer}>
        <ArtistButtons artistId={artistId} />
      </div>



      <div css={styles.broadcastContainer}>
        {!isLargeScreen &&
          <Broadcast id={artistId} type='artist' isOwner={isOwner} />
        }
      </div>


      <div css={styles.body}>
        {bio && 
          <InfoExpandingText text={bio} />
        }


        <ArtistBands artistId={artistId} links={links} setLinks={setLinks} />


        {website && 
          <DetailPageSection 
            icon={<GlobeIcon />} 
            Content={<WebsiteLink url={website} />} 
          />
        }


        {email && 
          <DetailPageSection
            icon={<MailIcon />} 
            Content={<WebsiteLink isMailLink={true} url={email} />} 
          />
        }


        {phoneNumber && 
          <DetailPageSection icon={<PhoneIcon />} text={phoneNumber} />
        }


        {hasExternalLinks &&
          <DetailPageSection Content={<LinksList links={externalLinks} />} />
        }
      </div>
      

      <div css={styles.footer}>
        <Tags tags={tags} margin='top' />
      </div>
    </div>
  )
}



const makeMapStateToProps = () => {
  const getArtistById = makeGetArtistById()


  const mapStateToProps = (state, props) => {

    const id = props.artistId

    const role = get(state, ['user', 'attributes', 'role'])
    
    const artist = getArtistById(state, id).attributes
    

    return {
      name: artist.name,
      bio: artist.bio,
      tags: artist.tags,
      views: artist.views,
      email: artist.email,
      address: artist.address,
      website: artist.website,
      phoneNumber: artist.phoneNumber,
      externalLinks: artist.links,
      isOwner: ['admin', 'editor'].includes(role) || (state.user.account.id === id)
    }
  }

  return mapStateToProps
}



export default connect(makeMapStateToProps)(ArtistInfo)





